import React from "react";
import $ from "$";
import { Row, Col, Button, Pagination, Menu, Dropdown, Icon } from "antd";
import isEmpty from "lodash/isEmpty";
import WeaLocaleProvider from "../../wea-locale-provider";
import WeaNewScroll from "../../wea-new-scroll";
import WeaBrowserTable from "../components/WeaBrowserTable";
import TableLeft from "../components/WeaTableLeft";
import WeaBrowserTree from "../components/WeaBrowserTree";
const { getLabel } = WeaLocaleProvider;

// 隐藏人员按钮点击事件
export function onButtonsClick(opt = "checkStrictly") {
  const { checkStrictly, isAccount, showAllbranch, activeKey } = this.state;
  let newState = {};
  let cb = () => {};
  if (opt == "showAllbranch") {
    newState = { showAllbranch: !showAllbranch };
    cb = () => this.onSearch({ cmd: "branch" }, activeKey);
  } else if (opt == "showAccount") {
    newState = { isAccount: !isAccount };
    cb = () => this.onSearch({}, activeKey);
  } else if (opt == "checkStrictly") {
    newState = { checkStrictly: !checkStrictly };
  }
  this.setState(newState, cb);
}

// 获取操作按钮
export function getTreeButtonInTrans(showButtons = {}, style = {}) {
  const { checkStrictlyTitle, type, showCheckStrictly } = this.props;
  const {
    checkStrictly,
    isAccount,
    showAllbranch,
    activeKey,
    contentType
  } = this.state;
  const btns = [];
  if (
    showCheckStrictly &&
    showButtons.showCheckStrictly
    // (contentType == 6 ||
    //   (contentType == 3 && (type != 142 || (type == 142 && activeKey == "2"))))
  ) {
    btns.push(
      <Button
        size="small"
        title={
          checkStrictlyTitle ||
          (checkStrictly
            ? getLabel(390067, "不包含下级机构")
            : getLabel(33454, "包含下级机构"))
        }
        onClick={() => this.onButtonsClick()}
      >
        <span>
          {checkStrictly ? (
            <i className="icon-coms-NoDisplayOfSubordinates" />
          ) : (
            <i
              className="icon-coms-DisplaySubordinates"
              style={{ color: "#2db7f5" }}
            />
          )}
        </span>
      </Button>
    );
  }
  if (showButtons.showAllbranch) {
    btns.push(
      <Button
        size="small"
        onClick={() => this.onButtonsClick("showAllbranch")}
        title={
          showAllbranch
            ? getLabel(390066, "隐藏下级下属")
            : getLabel(83783, "显示下级下属")
        }
      >
        <span>
          {showAllbranch ? (
            <i
              className="icon-coms-DisplaySubordinates"
              style={{ color: "#2db7f5" }}
            />
          ) : (
            <i className="icon-coms-NoDisplayOfSubordinates" />
          )}
        </span>
      </Button>
    );
  }
  if (showButtons.showAccount) {
    btns.push(
      <Button
        size="small"
        onClick={() => this.onButtonsClick("showAccount")}
        title={
          isAccount
            ? getLabel(385568, "隐藏无账号人员")
            : getLabel(31504, "显示无账号人员")
        }
      >
        <span>
          {isAccount ? (
            <i
              className="icon-coms-ShowNoAccount"
              style={{ color: "#2db7f5" }}
            />
          ) : (
            <i className="icon-coms-NoAccountNoDisplay" />
          )}
        </span>
      </Button>
    );
  }
  return (
    <div className="operation-wrap" style={style}>
      {btns}
    </div>
  );
}

export function onPageChange(current) {
  this.onSearch({ current }, this.state.activeKey);
}

// 获取分页
export function getPaginationInTrans() {
  const { pageSize, current, count } = this.state;
  return (
    <Pagination
      weaSimple
      showTotal={total => getLabel(385617, "共$s条").replace(/\$s/, total)}
      total={count}
      pageSize={pageSize}
      current={current}
      onChange={this.onPageChange}
    />
  );
}

export function onCompanySelect(item) {
  let params = {
    current: 1,
    virtualCompanyid: item.key || "1",
    ...this.getHrmParams(undefined, item.key)
  };
  this.getData(params);
}

// 获取虚拟维度下拉框
export function getDropMenuInTrans() {
  const { isSingle } = this.props;
  const { companyList, companyId } = this.state;
  let menuItem = [];
  companyList &&
    companyList.map(item => {
      menuItem.push(<Menu.Item key={item.companyid}>{item.name}</Menu.Item>);
      menuItem.push(<Menu.Divider />);
    });
  const company = companyList.find(item => item.companyid == companyId);
  const companyName = company && company.name ? company.name : "";
  const typeMenu = (
    <Menu
      className={`wea-browser-drop-menu max-height ${
        isSingle ? "" : "wea-hr-muti-input-drop-menu"
      }`}
      onSelect={this.onCompanySelect.bind(this)}
    >
      {menuItem}
    </Menu>
  );
  return (
    <Row>
      <Col span={24} style={{ fontSize: 0 }}>
        <Dropdown overlay={typeMenu} trigger={["click"]}>
          <a className="wea-dropdown-link" href="javascript:;">
            <span className="wea-dropdown-link-menuicon">
              <i className={"icon-toolbar-Organization-list"} />
            </span>
            <div
              className="text-elli wea-dropdown-link-company"
              title={companyName}
            >
              {companyName}
            </div>
            <span className="wea-dropdown-link-arrow">
              <Icon type="down" className="wea-dropdown-link-downicon" />
            </span>
          </a>
        </Dropdown>
      </Col>
    </Row>
  );
}

export function getContentHeight(show = {}) {
  const { contentHeight, isSingle, hasAdvanceSerach } = this.props;
  const { quickSearch } = this.state;
  const { showDropMenu, showPagination, showAdvanceSearch } = show;
  let cHeight = contentHeight;
  const tabs = this.getTabs();
  let showTabs =
    !isEmpty(tabs) || (isSingle && (hasAdvanceSerach || quickSearch));
  let delta = 0;
  if (showTabs) {
    delta += 47; // tab
  }
  if (showDropMenu) {
    delta += 37; // 下拉框
  }
  if (showAdvanceSearch) {
    delta += 35; // 高级搜索
  }
  if (showPagination) {
    delta += 35; // 分页组件
  }
  if (!isSingle) {
    delta += 21; // 多选列表有上下padding
  }
  if (window.setLayoutWindow) {
    let bodyHeight = $(window.setLayoutWindow.document.body).height();
    if (bodyHeight < 550) {
      bodyHeight = 550;
    }
    let maxH = bodyHeight - 100 - delta;
    if (cHeight > maxH) {
      cHeight = maxH;
    }
  } else {
    const widowClientHeight = document.documentElement.clientHeight || 0;
    if (widowClientHeight && cHeight > widowClientHeight - 120) {
      cHeight = widowClientHeight - 120;
    }
    if (cHeight < 270) {
      cHeight = 270;
    }
    cHeight -= delta;
  }
  return cHeight;
}

// 获取左侧列表高度
// export function getHeightInTrans() {
//   const { contentHeight } = this.props;
//   const { tabs } = this.props;
//   let height = contentHeight;
//   if (window.setLayoutWindow) {
//     let bodyHeight = $(window.setLayoutWindow.document.body).height();
//     if (bodyHeight < 550) {
//       bodyHeight = 550;
//     }
//     let maxH = bodyHeight - 220;
//     if (window.setDialogFullWindow || height > maxH) {
//       if (isEmpty(tabs)) {
//         maxH += 50;
//       }
//       height = maxH;
//     }
//   }
//   return height;
// }

// 获取穿梭框左侧内容
export function getModalMainContentLeft() {
  const {
    dataURL,
    icon,
    isImgIcon,
    type,
    topPrefix,
    asynLoadAll,
    defaultExpandedLevel
  } = this.props;
  const { hideVirtualOrg, showCheckStrictly } = this.props;
  const {
    contentType,
    dataOfListWithkey,
    dataOfListWithoutKeyAndPg,
    dataOfListWithoutKeyButPg,
    inputId,
    inputName,
    inputTop,
    inputBottom,
    selectedData,
    leftCheckedData,
    checkStrictly,
    leftTreeCheckedData,
    treeDatas,
    defaultExpandedKeys,
    loadAllTreeData,
    activeKey
  } = this.state;
  const isTree = contentType == 3;
  let content = null;
  if (isTree) {
    let _checkStrictly =
      checkStrictly && (type != 142 || (type == 142 && activeKey == "2"));
    content = isEmpty(treeDatas) ? (
      this.renderEmpty()
    ) : (
      <WeaBrowserTree
        ztreeMode={false}
        isImgIcon={isImgIcon}
        type={type}
        browserTree={false}
        onDoubleClick={this.onleftTreeDoubleClick}
        checkable={true}
        topPrefix={topPrefix}
        {...this.getAsyncParams()}
        checkedCb={this.onLeftTreeCheck.bind(this)}
        filterData={selectedData}
        inputId={inputId}
        inputName={inputName}
        inputTop={inputTop}
        inputBottom={inputBottom}
        checkedDatas={leftTreeCheckedData}
        isMult={true}
        icon={icon}
        treeData={treeDatas}
        defaultExpandedKeys={defaultExpandedKeys}
        checkStrictly={_checkStrictly}
        isLoadAll={loadAllTreeData}
        asynLoadAll={asynLoadAll}
        defaultExpandedLevel={defaultExpandedLevel}
      />
    );
  } else if (this.isCrm()) {
    return this.getHrmMainContent();
  } else {
    const leftCheckedKeys = leftCheckedData.map(item => item[inputId]);
    if (contentType == 3) {
      return null;
    }
    let keyProps = { datas: [] };
    if (contentType == 1) {
      keyProps = { datas: dataOfListWithkey };
    }
    if (contentType == 2) {
      keyProps = { datas: dataOfListWithoutKeyAndPg };
    }
    if (contentType == 4) {
      keyProps = {
        datas: !isEmpty(dataOfListWithoutKeyButPg)
          ? dataOfListWithoutKeyButPg.datas
          : []
      };
    }
    content = (
      <TableLeft
        {...keyProps}
        contentType={contentType}
        inputId={inputId}
        inputName={inputName}
        inputTop={inputTop}
        inputBottom={inputBottom}
        onDoubleClick={this.onleftDoubleClick}
        onClick={this.onleftClick}
        selectedKeys={leftCheckedKeys}
        filterData={selectedData}
        // datas={dataOfListWithkey}
      />
    );
  }

  let showDropMenu = contentType == 3 && (type == "194" || type == "57");
  if (hideVirtualOrg) {
    showDropMenu = false;
  }
  let showAdvanceSearch = !(contentType == 3 && type != 142);
  // let height = this.getHeightInTrans();
  const height = this.getContentHeight({
    showDropMenu,
    showAdvanceSearch,
    showPagination: contentType == 1 || contentType == 4
  });
  const showButtons = {
    showCheckStrictly:
      isTree && (type != 142 || (type == 142 && activeKey == "2"))
  };
  let btnsOffsetTop = 15;
  if (showDropMenu) {
    btnsOffsetTop += 37;
  }
  if (showAdvanceSearch) {
    btnsOffsetTop += 35;
  }
  return [
    this.getActionBarInTrans(showAdvanceSearch),
    isTree && showDropMenu && this.getDropMenuInTrans(),
    <div>
      <WeaNewScroll height={height} ref={el => (this.weaSrcoll = el)}>
        {content}
      </WeaNewScroll>
    </div>,
    isTree &&
      showCheckStrictly &&
      this.getTreeButtonInTrans(showButtons, { top: btnsOffsetTop }),
    (contentType == 1 || contentType == 4) && this.getPaginationInTrans()
  ].filter(Boolean);
}



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/browser/getTransformLeft.js